/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Store } from '@ngxs/store';
import { LaunchVideo, RequestVideoUrl } from '../../../state/report.actions';

@Component({
    selector: 'dash-gis-video-field',
    templateUrl: './video-field.component.html',
    styleUrls: ['./video-field.component.scss'],
})
export class VideoFieldComponent {
    @Input() public rowData: any;
    @Input() public fieldDefinition: any;

    constructor(private store: Store) {}

    initVideo(videoSource: string) {
        this.store.dispatch(new RequestVideoUrl({ videoSource }));
    }
}
